import { types } from "../types/types";


export const configFormularioReducer = (state = {},action) => {

    switch (action.type){
        
        // case types.configFormularioRecuperarConstantesFormulario:
        //     return {...state,
        //         constantesFormulario : action.contingut
        //         }
        // case types.configFormularioRecuperarIndicadoresFormulario:
        //     return {...state,
        //         indicadoresFormulario : action.contingut
        //         }
       case types.configFormularioInfo:
            return {...state,
                infoFormulario : action.contingut
                }
       case types.configFormularioCategoria:
            return {...state,
                infoFormularioCategoria : action.contingut
                }
        case types.configTextFormularioCategoria:
            return {...state,
                infoFormularioTextCategoria : action.contingut
                }
        case types.configConstantesFormularioCategoria:
            return {...state,
                infoFormularioConstantesCategoria : action.contingut
                }
        case types.configIndicadoresFormularioCategoria:
            return {...state,
                infoFormularioIndicadoresCategoria : action.contingut
                }
        case types.configFormularioResultats:
            return {...state,
                resultatsCategoria : action.contingut
                }
        case types.configActualizarTextoCategoria:
                    return {
                        ...state,
                        infoFormularioTextCategoria: {
                            ...state.infoFormularioTextCategoria,
                            [action.categoria]: {
                                // Mantenemos los textos existentes y solo actualizamos los modificados
                                ...state.infoFormularioTextCategoria[action.categoria],
                                ...action.nuevosTextos, // AquÃ­ aplicamos las modificaciones
                            },
                        },
        };
        
        case types.configActualizarConstantesCategoria:
                        return {
                            ...state,
                            infoFormularioConstantesCategoria: {
                                ...state.infoFormularioConstantesCategoria,
                                nuevaVersion: {
                                    ...state.infoFormularioConstantesCategoria.nuevaVersion,
                                    [action.categoria]: {
                                        // Mantener las constantes existentes y actualizar las nuevas
                                        ...state.infoFormularioConstantesCategoria.nuevaVersion[action.categoria],
                                        ...action.nuevasConstantes,
                                    }
                                }
                            }
                        };
            case types.configActualizarIndicadoresCategoria:
                            return {
                                ...state,
                                infoFormularioIndicadoresCategoria: {
                                    ...state.infoFormularioIndicadoresCategoria,
                                    nuevaVersion: {
                                        ...state.infoFormularioIndicadoresCategoria.nuevaVersion,
                                        [action.categoria]: action.nuevasIndicadores
                                    }
                                }
                            };



        case types.textosPDFRecuperarInfo:
            return { ...state, textosPDF: action.payload.contingut };

        case types.textosPDFActualizarTexto: {
            if (!state.textosPDF) return state;
            const { idTextoPDF, texto } = action.payload;
            const pdf = state.textosPDF;

            const rf = { ...pdf.resultado_final };
            Object.keys(rf).forEach(n => {
                if (rf[n]?.IdTextoPDF === idTextoPDF) rf[n] = { ...rf[n], Texto: texto };
            });

            const cats = {};
            Object.keys(pdf.categorias || {}).forEach(cat => {
                cats[cat] = { ...pdf.categorias[cat] };
                Object.keys(cats[cat]).forEach(n => {
                    if (cats[cat][n]?.IdTextoPDF === idTextoPDF) cats[cat][n] = { ...cats[cat][n], Texto: texto };
                });
            });

            const pregs = {};
            Object.keys(pdf.preguntas || {}).forEach(cat => {
                pregs[cat] = {};
                Object.keys(pdf.preguntas[cat]).forEach(preg => {
                    pregs[cat][preg] = { ...pdf.preguntas[cat][preg] };
                    Object.keys(pregs[cat][preg]).forEach(n => {
                        if (pregs[cat][preg][n]?.IdTextoPDF === idTextoPDF) pregs[cat][preg][n] = { ...pregs[cat][preg][n], Texto: texto };
                    });
                });
            });

            return { ...state, textosPDF: { ...pdf, resultado_final: rf, categorias: cats, preguntas: pregs } };
        }

        default:
            return state;
    }

}